import React from "react"
import FieldProto from "../proto/field-proto";

export type FieldViewSmallProps = {
    field       : FieldProto
    model       : any
    options?    : any
    className?  : string
    onClick?    : onClick
};

export default function FieldViewSmall(props:FieldViewSmallProps):React.ReactElement {

    return <props.field.renderComponents.viewSmall {...props} />

}